import * as React from "react";
import { SVGProps } from "react";
export const SvgDropdown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 7 16 7 10 13z"
      stroke="none"
      strokeWidth={1}
      fillRule="evenodd"
    />
  </svg>
);
